export default __webpack_public_path__ + "static/media/StonexLogo.a47cf3ca.svg";